import type { Patient } from '@medplum/fhirtypes';
import type { IntakeAnswers } from './types';

function patientEmail(patient: Patient): string {
  return patient.telecom?.find((t) => t.system === 'email')?.value?.trim() ?? '';
}

function patientZip(patient: Patient): string {
  const home = patient.address?.find((a) => a.use === 'home') ?? patient.address?.[0];
  return home?.postalCode?.trim().slice(0, 5) ?? '';
}

/** Map an existing Patient into intake answer fields used on submit. */
export function intakeAnswersFromPatient(patient: Patient): Partial<IntakeAnswers> {
  const name = patient.name?.find((n) => n.use === 'official') ?? patient.name?.[0];
  const firstName = name?.given?.[0]?.trim() ?? '';
  const lastName = name?.family?.trim() ?? '';
  return {
    firstName,
    lastName,
    email: patientEmail(patient),
    dateOfBirth: patient.birthDate?.trim() ?? '',
    zip: patientZip(patient),
    emailVerified: true,
  };
}
